import type { FormErrorEvent, FormSubmitEvent } from '#ui/types'

export async function onFormValidationError(event: FormErrorEvent) {
  const toast = useToast()
  toast.add({
    title: 'Error',
    description: event.errors[0].message,
    color: 'red',
    icon: 'ri:error-warning-line',
  })
  const element = document.getElementById(event.errors[0].id ?? 'logo')
  element?.focus()
  element?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

export function useSubmitError() {
  const toast = useToast()

  const displayError = (event: { message: string, status: number, data: Record<string, any> }) => {
    const errors = Object.entries(event.data.data).map(([field, error]) => ({
      field,
      message: convertErrorMessage(error?.message ?? ''),
    }))
    errors.forEach((error) => {
      toast.add({
        title: `Error saving - ${error.field}`,
        description: error.message,
        color: 'red',
        icon: 'ri:error-warning-line',
      })
    })
    if (!errors.length) {
      return
    }
    const element = document.getElementById(errors[0]?.field ?? '')
    element?.focus()
    element?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
  return {
    displayError,
  }
}

function convertErrorMessage(errorMessage: string) {
  const match = errorMessage.match(/(\d+)\sbytes/)
  if (match) {
    const bytes = parseInt(match[1])
    return `The maximum allowed file size is ${bytes / 1024 / 1024} MB`
  }
  return errorMessage
}
